import axiosInstance from "@/lib/axiosInstance";
import type { FileManagerItem } from "@/components/core/FileManager";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import type {
  DocumentActionPayload,
  DocumentMutationResponse,
  DocumentsListResponse,
  GenerateUploadUrlsPayload,
  GenerateUploadUrlsResponse,
} from "./documents.types";

export const DocumentsQueryKeys = {
  list: "documents-list",
} as const;

export const getDocumentItems = async (
  documentsPath: string,
  parentId: string | null,
  search: string | null,
): Promise<FileManagerItem[]> => {
  const params: Record<string, string> = {};
  if (parentId) params.parentId = parentId;
  if (search) params.search = search;

  const { data } = await axiosInstance.get<DocumentsListResponse>(documentsPath, { params });
  return data.data.items;
};

export const updateDocuments = async (
  documentsPath: string,
  payload: DocumentActionPayload,
): Promise<DocumentMutationResponse["data"]> => {
  const { data } = await axiosInstance.put<DocumentMutationResponse>(documentsPath, payload, {
    suppressErrorAlert: true,
  } as CustomAxiosRequestConfig);
  return data.data;
};

export const generateDocumentUploadUrls = async (
  documentsPath: string,
  payload: GenerateUploadUrlsPayload,
): Promise<GenerateUploadUrlsResponse["data"]> => {
  const { data } = await axiosInstance.put<GenerateUploadUrlsResponse>(documentsPath, payload);
  return data.data;
};
